module.exports = __webpack_public_path__ + "img/pg_logo_blue.5b8743e3.png";